/**
 * Раскладка в формате Марата (задания №1–4, «Промпт аукционы.docx»): рендер берёт готовый
 * screening_json.marat_report (Х-2, services/tender_screening.py: marat_report). У раскладок
 * старого формата его нет — инспектор предлагает «Разложить заново», логику бэкенда здесь
 * не повторяем. Без DOM — тестируется в node.
 */

/** Статус рекомендации словами (карточка итога). */
export const REC_WORD = { go: 'Участвовать', borderline: 'На грани', no_go: 'Отказ', incomplete: 'Неполная' };

/** «1 234,5 км» — как _num на бэкенде. */
export function num(v, unit = '') {
  if (v == null || v === '' || !Number.isFinite(Number(v))) return null;
  const s = Number(v).toLocaleString('ru-RU', { maximumFractionDigits: 2 }).replace(/\u00a0/g, ' ');
  return `${s} ${unit}`.trim();
}

/** «документ, пункт» из {document, clause} (цитата разночтения task3). */
export function citeText(c) {
  if (!c || typeof c !== 'object') return c || null;
  return [c.document, c.clause].filter(Boolean).join(', ') || null;
}

/** marat_report из screening_json; null — раскладки нет или она старого формата. */
export const maratReport = (sj) => sj?.marat_report ?? null;

/** Раскладка есть, но без marat_report (до Х-2). */
export const isLegacyScreening = (sj) => !!sj && !sj.marat_report;

/** Каких документов не хватает для цены: ['договор', 'ТЗ'] (оба — если данных нет). */
export function missingDocs(sj) {
  const c = sj?.completeness;
  if (!c) return ['договор', 'ТЗ'];
  return [!c.contract ? 'договор' : null, !c.tz ? 'ТЗ' : null].filter(Boolean);
}

const KIND_WORD = { contract: 'договор', calendar_plan: 'календарный план', tz: 'ТЗ' };

/**
 * Строка «В раскладку вошло: договор (целиком), ТЗ (обрезано 150 000 из 212 000 символов);
 * не вошло: смета.docx» из extraction.documents (Х-2). null — сводки нет (старая раскладка).
 */
export function docsLine(sj) {
  const docs = sj?.extraction?.documents;
  if (!docs || !Array.isArray(docs.files)) return null;
  const name = (f) => (KIND_WORD[f.doc_kind] ? `${KIND_WORD[f.doc_kind]} «${f.filename ?? '—'}»` : `«${f.filename ?? '—'}»`);
  const inc = docs.files.filter((f) => f.status !== 'omitted').map((f) => (f.status === 'full'
    ? `${name(f)} (целиком)`
    : `${name(f)} (обрезано ${num(f.sent)} из ${num(f.chars)} символов)`));
  const omitted = docs.files.filter((f) => f.status === 'omitted').map(name);
  if (!inc.length && !omitted.length) return 'В раскладку не вошло ни одного документа с текстом.';
  return `В раскладку вошло: ${inc.join(', ') || 'ничего'}${omitted.length ? `; не вошло: ${omitted.join(', ')}` : ''}.`;
}
